import en from './en';
import ru from './ru';
import uk from './uk';

const locales = {
  en: {
    locale: en,
    shortTitle: 'Eng',
    title: 'English',
    icon: '🇺🇸',
  },
  ru: {
    locale: ru,
    shortTitle: 'Рус',
    title: 'Русский',
    icon: '🏳️',
  },
  uk: {
    locale: uk,
    shortTitle: 'Укр',
    title: 'Українська',
    icon: '🇺🇦',
  }
};

export const getLocale = (locale: string) => locales[locale]?.locale;

export default locales;
